import $ from 'jquery';

export default function preventFormMailSpam() {
    $('form.su-form-mail').each(function() {
        var $form = $(this);
        $form.attr('action', 'https://www.swansea.ac.uk/cgi-bin/form_mail.pl');
        $form.find('[type="submit"]').removeAttr('disabled');
        $form.find('.su-form-mail-no-js').remove();
    });
}
